module.exports = __webpack_public_path__ + "static/media/bedWrong.7225a9a0.png";